import React from 'react'
import { constraintConfig } from '../../../constraintConfig'

type Props = {
    itemData?: any
}

const CATEGORY_ICONS: Record<number, { src: string; label: string }> = {
    [constraintConfig.categoriesId.travelExpenses]: {
        src: '/media/category-icons/Travel Expenses.svg',
        label: constraintConfig.categoriesName.travelExpenses,
    },
    [constraintConfig.categoriesId.entertainmentExpenses]: {
        src: '/media/category-icons/Entertainment Expenses.svg',
        label: constraintConfig.categoriesName.entertainmentExpenses,
    },
    [constraintConfig.categoriesId.officeSuppliesAndStationery]: {
        src: '/media/category-icons/Office Supplies And Stationery.svg',
        label: constraintConfig.categoriesName.officeSuppliesAndStationery,
    },
    [constraintConfig.categoriesId.communicationExpenses]: {
        src: '/media/category-icons/Communication Expenses.svg',
        label: constraintConfig.categoriesName.communicationExpenses,
    },
    [constraintConfig.categoriesId.mealsAndRefreshments]: {
        src: '/media/category-icons/Meals And Refreshments.svg',
        label: constraintConfig.categoriesName.mealsAndRefreshments,
    },
    [constraintConfig.categoriesId.trainingAndProfessionalDevelopment]: {
        src: '/media/category-icons/Training And Professional Development.svg',
        label: constraintConfig.categoriesName.trainingAndProfessionalDevelopment,
    },
    [constraintConfig.categoriesId.marketingAndAdvertising]: {
        src: '/media/category-icons/Marketing And Advertising.svg',
        label: constraintConfig.categoriesName.marketingAndAdvertising,
    },
    [constraintConfig.categoriesId.utilities]: {
        src: '/media/category-icons/Utilities.svg',
        label: constraintConfig.categoriesName.utilities,
    },
    [constraintConfig.categoriesId.maintenanceAndRepairs]: {
        src: '/media/category-icons/Maintenance And Repairs.svg',
        label: constraintConfig.categoriesName.maintenanceAndRepairs,
    },
    [constraintConfig.categoriesId.professionalServices]: {
        src: '/media/category-icons/Professional Services.svg',
        label: constraintConfig.categoriesName.professionalServices,
    },
    [constraintConfig.categoriesId.insurancePremiums]: {
        src: '/media/category-icons/Insurance Premiums.svg',
        label: constraintConfig.categoriesName.insurancePremiums,
    },
    [constraintConfig.categoriesId.officeEquipmentandFurniture]: {
        src: '/media/category-icons/Office Equipment And Furniture.svg',
        label: constraintConfig.categoriesName.officeEquipmentandFurniture,
    },
    [constraintConfig.categoriesId.miscellaneousExpenses]: {
        src: '/media/category-icons/Miscellaneous Expenses.svg',
        label: constraintConfig.categoriesName.miscellaneousExpenses,
    },
    [constraintConfig.categoriesId.mileage]: {
        src: '/media/category-icons/Mileage.svg',
        label: constraintConfig.categoriesName.mileage,
    },
    [constraintConfig.categoriesId.companyEntertainment]: {
        src: '/media/category-icons/Entertainment Expenses.svg',
        label: constraintConfig.categoriesName.companyEntertainment,
    },
}

const getCategoryTone = (itemData?: any): 'mileage' | 'cc' | 'reimbursable' => {
    const categoryId = itemData?.expenseCategory?.id
    const categoryTitle = String(itemData?.expenseCategory?.title || '').toLowerCase()
    if (
        categoryId === constraintConfig.categoriesId.mileage ||
        categoryId === constraintConfig.expenseCategoryID.mileage ||
        categoryTitle.includes('mileage')
    ) {
        return 'mileage'
    }

    const methodId = itemData?.paymentMethod?.id
    const methodTitle = String(itemData?.paymentMethod?.title || '').toLowerCase()
    const isCorporateCard =
        methodId === constraintConfig.paymentMethod.corporateCreditCard ||
        methodId === constraintConfig.paymentMethod.adcsCorporateCreditCard ||
        methodTitle.includes('corporate credit card')

    if (isCorporateCard) {
        return 'cc'
    }

    return 'reimbursable'
}

const CategoriesWithIcons = ({ itemData }: Props) => {
    const categoryId = itemData?.expenseCategory?.id
    const mapped = categoryId != null ? CATEGORY_ICONS[categoryId] : undefined
    const label = mapped?.label || itemData?.expenseCategory?.title || ''
    const src = mapped?.src || '/media/category-icons/Entertainment Expenses.svg'
    const tone = getCategoryTone(itemData)

    return (
        <div className={`d-flex gap-2 align-items-center ss-category-chip ss-category-chip--${tone}`}>
            <span className='ss-category-chip__icon' aria-hidden='true'>
                <img src={src} alt='' height='20' width='20' />
            </span>
            <span>{label}</span>
        </div>
    )
}

export default CategoriesWithIcons
